import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Spinner, SimpleTable, Pager } from "@/components/app/common";
import { PackageCard, CheckoutDialog } from "@/components/app/Checkout";
import { api, tl, dt, num } from "@/lib/api";
import { StatusBadge, METHODS } from "@/lib/labels";

export default function Purchase() {
  const [products, setProducts] = useState(null);
  const [buy, setBuy] = useState(null);
  const [orders, setOrders] = useState(null);
  const [page, setPage] = useState(1);
  useEffect(() => { api.get("/products").then(({ data }) => setProducts(data.filter((p) => p.kind === "CREDIT"))); }, []);
  useEffect(() => { api.get("/orders", { params: { page } }).then(({ data }) => setOrders(data)); }, [page, buy]);
  return (
    <div data-testid="purchase-page">
      <PageHeader title="Kredi Satın Al" desc="Kartla anında veya Havale/EFT ile indirimli ödeme yapın." />
      {!products ? <Spinner /> : (
        <div className="grid gap-5 pt-3 sm:grid-cols-2 xl:grid-cols-4">{products.map((p) => <PackageCard key={p.id} p={p} onBuy={setBuy} />)}</div>
      )}
      <h2 className="mb-4 mt-14 text-lg font-semibold">Siparişlerim</h2>
      {orders && (
        <>
          <SimpleTable testid="my-orders-table" rows={orders.items} cols={[
            { key: "order_no", label: "Sipariş No", render: (o) => <Link to={`/siparis/${o.id}`} className="font-semibold text-primary" data-testid={`order-link-${o.order_no}`}>{o.order_no}</Link> },
            { key: "p", label: "Paket", render: (o) => o.product_snapshot.name },
            { key: "c", label: "Kredi", render: (o) => num(o.credits) },
            { key: "m", label: "Yöntem", render: (o) => METHODS[o.payment_method] },
            { key: "a", label: "Tutar", render: (o) => tl(o.final_amount) },
            { key: "s", label: "Durum", render: (o) => <StatusBadge status={o.status} /> },
            { key: "d", label: "Tarih", render: (o) => dt(o.created_at) },
          ]} empty="Henüz siparişiniz yok." />
          <Pager page={orders.page} pages={orders.pages} onChange={setPage} />
        </>
      )}
      <CheckoutDialog product={buy} onClose={() => setBuy(null)} />
    </div>
  );
}
